<template>
  <div class="home">
    <div
      class="home-header"
      :class="{ 'home-header-mobile': isMobile }"
      :style="{ backgroundImage: isMobile ? 'url(' + bgImageUrl + ')' : '' }"
    >
      <div class="home-header-layer"></div>
      <div class="flex flex-center flex-column" style="z-index: 10">
        <div class="header-title-bg-box" :class="{ 'header-title-bg-box-mobile': isMobile }">
          <div class="header-title-bg"></div>
          <div class="header-title-text">
            <img
              v-if="!isMobile"
              class="header-logo"
              :src="require('@/assets/images/hsk_mock_logo.svg')"
            />
            <p
              class="header-title"
              :class="{ 'header-title-mobile': isMobile }"
              v-html="$t('tofficial_platform_new')"
            ></p>
            <p class="header-desc" :class="{ 'header-desc-mobile': isMobile }">
              {{ $t('proficiency_tests_new') }}
            </p>
          </div>
        </div>
        <mui-button
          type="yellow"
          class="started"
          :class="{ 'started-mobile': isMobile }"
          @click="onClickHeroStart"
        >{{ $t('start_practicing') }}</mui-button
        >
        <div class="download-app-box" v-if="isMobile">
          <!-- <div class="download-app-title">{{ $t('use_pc_or_app') }}</div> -->
          <!--          <DownLoadApp-->
          <!--            :isMobile="isMobile"-->
          <!--            :whiteIcon="true"-->
          <!--            :isColumn="false"-->
          <!--            :gap="9"-->
          <!--            @handleClick="handleClick"-->
          <!--          ></DownLoadApp>-->
        </div>
      </div>
      <!-- <div v-if="!isChina && !isMobile" class="home-pay-tip-box">
        <i class="el-icon-warning-outline" style="color: #ffffff"></i>
        <div class="pay-tip-front">
          {{ $t('pay_tip') }}
        </div>
      </div> -->
      <!-- <div class="home-header-footer" :class="{ 'home-header-footer-mobile': isMobile }" v-if="isChinese">
        <span>{{ $t("platform_china") }}</span>
        <el-tooltip effect="dark" :content="$t('international_platform')" placement="top">
          <SvgIcon type="info" class="icon-18" />
        </el-tooltip>
      </div> -->
    </div>
    <div class="home-main-full" :class="{ 'home-main-mobile': isMobile }">
      <div class="confidence" :class="{ 'confidence-mobile': isMobile }">
        <h1 class="confidence-header" :class="{ 'confidence-header-mobile': isMobile }">
          {{ $t('get_ready') }}
        </h1>
        <div class="confidence-card" :class="{ 'confidence-card-mobile': isMobile }">
          <!-- 卡片0：Check Your HSK Level -->
          <div class="confidence-card-wrapper">
            <div
              class="confidence-card-item"
              :class="{ 'is-active': activeCardIndex === 0 }"
              @click="handleCardClick(0)"
            >
              <div class="confidence-card-item-inner">
                <img class="confidence-card-item-icon" :src="confidenceList[0]?.icon" />
                <div class="confidence-card-item-title">{{ confidenceList[0]?.title }}</div>
                <div class="confidence-card-item-desc">{{ confidenceList[0]?.desc }}</div>
              </div>
            </div>
            <!-- 卡片0详情区 -->
            <div v-if="activeCardIndex === 0" class="confidence-detail-mobile">
              <p class="confidence-detail-desc">{{ $t('confidence_card0_detail_desc') }}</p>
              <mui-button type="yellow" class="confidence-detail-btn" @click="onClickCard0LevelTest">
                {{ $t('confidence_card0_detail_btn') }}
              </mui-button>
            </div>
          </div>
          <!-- 卡片1：Take a Real HSK Mock Test -->
          <div class="confidence-card-wrapper">
            <div
              class="confidence-card-item"
              :class="{ 'is-active': activeCardIndex === 1 }"
              @click="handleCardClick(1)"
            >
              <div class="confidence-card-item-inner">
                <img class="confidence-card-item-icon" :src="confidenceList[1]?.icon" />
                <div class="confidence-card-item-title">{{ confidenceList[1]?.title }}</div>
                <div class="confidence-card-item-desc">{{ confidenceList[1]?.desc }}</div>
              </div>
            </div>
            <!-- 卡片1详情区 -->
            <div v-if="activeCardIndex === 1" class="confidence-detail-mobile">
              <p class="confidence-detail-title">{{ $t('confidence_choose_level') }}</p>
              <div class="confidence-level-tags">
                <span
                  v-for="(level, i) in hskLevels"
                  :key="i"
                  class="confidence-level-tag"
                  :class="{ active: selectedLevel === level }"
                  @click="selectedLevel = level"
                >{{ level }}</span>
              </div>
              <mui-button type="yellow" class="confidence-detail-btn" @click="onClickCard1MockTest">
                {{ $t('confidence_card1_detail_btn') }}
              </mui-button>
            </div>
          </div>
          <!-- 卡片2：Improve Your Vocabulary -->
          <div class="confidence-card-wrapper">
            <div
              class="confidence-card-item"
              :class="{ 'is-active': activeCardIndex === 2 }"
              @click="handleCardClick(2)"
            >
              <div class="confidence-card-item-inner">
                <img class="confidence-card-item-icon" :src="confidenceList[2]?.icon" />
                <div class="confidence-card-item-title">{{ confidenceList[2]?.title }}</div>
                <div class="confidence-card-item-desc">{{ confidenceList[2]?.desc }}</div>
              </div>
            </div>
            <!-- 卡片2详情区 -->
            <div v-if="activeCardIndex === 2" class="confidence-detail-mobile">
              <p class="confidence-detail-title">{{ $t('confidence_choose_level') }}</p>
              <div class="confidence-level-tags">
                <span
                  v-for="(level, i) in hskLevels"
                  :key="i"
                  class="confidence-level-tag"
                  :class="{ active: selectedLevel === level }"
                  @click="selectedLevel = level"
                >{{ level }}</span>
              </div>
              <p class="confidence-detail-title m-t-20">{{ $t('confidence_choose_method') }}</p>
              <div class="confidence-method-btns">
                <button
                  v-for="(method, i) in practiceMethodList"
                  :key="i"
                  class="confidence-method-btn"
                  :class="`method-${method.key}`"
                  @click="onClickPracticeMethod(method.key)"
                >{{ method.label }}</button>
              </div>
            </div>
          </div>
        </div>

        <!-- PC端：统一显示在三个卡片下方的详情区 -->
        <div class="confidence-detail" v-if="!isMobile">
          <!-- 卡片0：Check Your HSK Level -->
          <div v-if="activeCardIndex === 0" class="confidence-detail-content">
            <p class="confidence-detail-desc">{{ $t('confidence_card0_detail_desc') }}</p>
            <mui-button type="yellow" class="confidence-detail-btn" @click="onClickCard0LevelTest">
              {{ $t('confidence_card0_detail_btn') }}
            </mui-button>
          </div>
          <!-- 卡片1：Take a Real HSK Mock Test -->
          <div v-else-if="activeCardIndex === 1" class="confidence-detail-content">
            <p class="confidence-detail-title">{{ $t('confidence_choose_level') }}</p>
            <div class="confidence-level-tags">
              <span
                v-for="(level, i) in hskLevels"
                :key="i"
                class="confidence-level-tag"
                :class="{ active: selectedLevel === level }"
                @click="selectedLevel = level"
              >{{ level }}</span>
            </div>
            <mui-button type="yellow" class="confidence-detail-btn" @click="onClickCard1MockTest">
              {{ $t('confidence_card1_detail_btn') }}
            </mui-button>
          </div>
          <!-- 卡片2：Improve Your Vocabulary -->
          <div v-else-if="activeCardIndex === 2" class="confidence-detail-content">
            <p class="confidence-detail-title">{{ $t('confidence_choose_level') }}</p>
            <div class="confidence-level-tags">
              <span
                v-for="(level, i) in hskLevels"
                :key="i"
                class="confidence-level-tag"
                :class="{ active: selectedLevel === level }"
                @click="selectedLevel = level"
              >{{ level }}</span>
            </div>
            <p class="confidence-detail-title m-t-20">{{ $t('confidence_choose_method') }}</p>
            <div class="confidence-method-btns">
              <button
                v-for="(method, i) in practiceMethodList"
                :key="i"
                class="confidence-method-btn"
                :class="`method-${method.key}`"
                @click="onClickPracticeMethod(method.key)"
              >{{ method.label }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home-main-full how-work-container" :class="{ 'home-main-mobile': isMobile }">
      <div class="how-work" :class="{ 'how-work-mobile': isMobile }">
        <h1 class="how-work-header" :class="{ 'how-work-header-mobile': isMobile }">
          {{ $t('how_it_works') }}
        </h1>
        <div class="how-work-card" :class="{ 'how-work-card-mobile': isMobile }">
          <div v-for="(item, index) in howWorkList" :key="index" class="how-work-card-item">
            <div class="how-work-card-item-inner">
              <div class="how-work-card-item-icon" :src="item.icon">{{ index + 1 }}</div>
              <div class="how-work-card-item-title">{{ item.title }}</div>
              <div class="how-work-card-item-desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>

        <mui-button
          v-if="!isMobile"
          type="yellow"
          class="started"
          :class="{ 'started-mobile': isMobile }"
          @click="onClickHowItWorksStart"
        >{{ $t('get_started_new') }}</mui-button
        >
      </div>
    </div>

    <div class="banner home-main-full">
      <!-- <img
        src="@/assets/images/home/rectangle.png"
        alt=""
        style="width: 100%; display: block"
        v-if="isMobile"
      /> -->
      <!-- <img
        src="@/assets/images/home/rectangle.png"
        alt=""
        style="width: 100%; display: block"
        v-else
      /> -->
      <div class="banner-title" :class="{ 'banner-title-mobile': isMobile }">{{ $t('real_results_from_real_learners') }}</div>
      <div class="banner-bg">
        <div class="banner-box" v-if="!isMobile">
          <div class="swiper" id="certify" v-if="banners && banners.length > 0">
            <div class="swiper-container banner-container">
              <div class="swiper-wrapper" style="padding: 16px 0">
                <div class="swiper-slide" v-for="(item, index) in banners" :key="index">
                  <div class="banner-card">
                    <div style="display: flex; align-items: center; column-gap: 8px">
                      <img :src="getImagePath(index)" alt="" class="banner-card-img" />
                      <h1 class="banner-card-title" style="white-space: pre-wrap">
                        {{ item.title }}
                      </h1>
                    </div>
                    <p class="banner-card-text">{{ item.text }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="banner-button-prev">
            <SvgIcon type="left-arrow" class="icon-24" :handle="onClickLeftArrow" />
          </div>
          <div class="banner-button-next">
            <SvgIcon type="right-arrow" class="icon-24" :handle="onClickRightArrow" />
          </div> -->
        </div>
        <div v-else class="banner-box-mobile">
          <div class="swiper" id="certifyMobile">
            <div class="swiper-container swiper-container-mobile">
              <div
                class="swiper-wrapper"
                v-if="banners && banners.length > 0"
                style="padding: 16px 0"
              >
                <div
                  class="swiper-slide swiper-slide-mobile"
                  v-for="(item, index) in banners"
                  :key="index"
                >
                  <div class="banner-card-mobile">
                    <img :src="getImagePath(index)" alt="" class="banner-card-mobile-img" />
                    <h1 class="banner-card-mobile-title" style="white-space: pre-wrap">
                      {{ item.title }}
                    </h1>

                    <p class="banner-card-mobile-text">{{ item.text }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="download-swiper-title">{{ $t('use_pc_or_app') }}</div>
            <DownLoadApp
              :isMobile="isMobile"
              :isColumn="false"
              :gap="12"
              @handleClick="handleClick"
            ></DownLoadApp> -->
            <div class="banner-pagination"></div>
          </div>
        </div>
        <div class="started-btn flex flex-center" v-if="!isMobile">
          <mui-button type="yellow" class="get-started" @click="onClickBannerStart">{{
              $t('start_learning')
            }}</mui-button>
          <a href="" v-if="false" class="experience">Share your experience</a>
        </div>
      </div>
    </div>

    <div class="flex flex-center move" :class="{ 'move-mobile': isMobile }">
      <!-- <div class="home-header-layer"></div> -->
      <!-- <img
        src="@/assets/images/home/more-title-bg-mobile.png"
        alt=""
        class="more-title-bg more-title-bg-mobile"
        v-if="isMobile"
      /> -->
      <!-- <img src="@/assets/images/home/more-title-bg.png" alt="" class="more-title-bg" v-else /> -->
      <!-- <img
        src="@/assets/images/home/more-footer-bg-mobile.png"
        alt=""
        class="more-footer-bg more-footer-bg-mobile"
        v-if="isMobile"
      /> -->
      <!-- <img src="@/assets/images/home/more-footer-bg.png" alt="" class="more-footer-bg" v-else /> -->
      <div style="z-index: 10">
        <h1 class="move-title" :class="{ 'move-title-mobile': isMobile }">
          {{ $t('on_the_move_new') }}
        </h1>
        <p class="more-desc" :class="{ 'more-desc-mobile': isMobile }">
          {{ $t('download_mobile_new') }}
        </p>
        <DownLoadApp :isMobile="isMobile" @handleClick="handleClick"></DownLoadApp>
        <!-- <div class="download" :class="{ 'download-mobile': isMobile }">
          <div
            class="clickable download-item android"
            :class="{ 'download-item-mobile': isMobile }"
            @click="handleClick('app-store')"
          ></div>
          <div
            class="clickable download-item app-store"
            :class="{ 'download-item-mobile': isMobile }"
            :style="{ marginLeft: isMobile ? '0px' : '150px' }"
            @click="handleClick('android')"
          ></div>
          <div
            class="clickable download-item google-play"
            :class="{ 'download-item-mobile': isMobile }"
            @click="handleClick('google-play')"
            :style="{ marginLeft: isMobile ? '0px' : '150px' }"
            v-if="!isChina"
          ></div>
        </div> -->
      </div>
    </div>

    <div class="institutional-section" :class="{ 'institutional-section-mobile': isMobile }">
      <div class="institutional-ring"></div>
      <div class="institutional-container">
        <h1 class="institutional-title">{{ $t('institutional_title') }}</h1>
        <div class="institutional-card" :class="{ 'institutional-card-mobile': isMobile }">
          <div class="institutional-left">
            <div class="institutional-swiper" ref="institutionalSwiper">
              <div class="institutional-swiper-wrapper">
                <div
                  v-for="(img, index) in institutionalImages"
                  :key="index"
                  class="institutional-swiper-slide"
                  :class="{ active: currentInstitutionalSlide === index }"
                >
                  <img class="institutional-image" :src="img" :alt="`Slide ${index + 1}`" />
                </div>
              </div>
            </div>
          </div>
          <div class="institutional-right">
            <p class="institutional-desc">{{ $t('institutional_desc') }}</p>
            <div class="institutional-item">
              <div class="institutional-item-title">
                <span class="institutional-bullet"></span>
                {{ $t('institutional_schools_title') }}
              </div>
              <p class="institutional-item-desc">{{ $t('institutional_schools_desc') }}</p>
            </div>
            <div class="institutional-item">
              <div class="institutional-item-title">
                <span class="institutional-bullet"></span>
                {{ $t('institutional_corp_title') }}
              </div>
              <p class="institutional-item-desc">{{ $t('institutional_corp_desc') }}</p>
            </div>
          </div>
        </div>
        <mui-button
          type="yellow"
          class="institutional-btn"
          @click="onClickInstitutional"
        >{{ $t('institutional_btn') }}</mui-button
        >
      </div>
    </div>

    <div class="home-main-full" :class="{ 'home-main-mobile': isMobile }">
      <div class="answers" :class="{ 'answers-mobile': isMobile }">
        <h1 class="answers-header" :class="{ 'answers-header-mobile': isMobile }">
          {{ $t('got_questions') }}
        </h1>
        <div class="answers-card" :class="{ 'answers-card-mobile': isMobile }">
          <div v-for="(item, index) in answersList" :key="index" class="answers-card-item">
            <div class="answers-card-item-inner">
              <img class="answers-card-item-icon" :src="item.icon" />
              <div class="answers-card-item-title">{{ item.title }}</div>
              <div class="answers-card-item-desc">{{ item.desc }}</div>
              <a v-if="item.isExternal" class="answers-card-item-btn" :href="`/${isChinese ? 'en' : 'cn'}${item.link}`">
                <span>{{ item.btnStr }}</span>
                <img :src="require('@/assets/images/arrow-right.svg')" />
              </a>
              <router-link v-else class="answers-card-item-btn" :to="item.link">
                <span>{{ item.btnStr }}</span>
                <img :src="require('@/assets/images/arrow-right.svg')" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="level" :style="{ marginBottom: isMobile ? '40px' : '' }">
      <div class="flex flex-center" :class="{ 'level-mobile': isMobile }">
        <div
          class="level-card"
          style="background: #dce7da"
          :class="{ 'level-card-mobile': isMobile }"
        >
          <img src="@/assets/images/home/home-hsk-170.png" alt="" />
          <p
            :style="{ marginTop: isMobile ? '20px' : '38px' }"
            v-html="$t('hsk_beginner_advanced')"
          ></p>
          <router-link to="/chooselevel/index" class="look-more"
            ><span @click="onClickMoreHsk">{{ $t('more') }}</span></router-link
          >
        </div>
        <div
          class="level-card"
          :class="{ 'level-card-mobile': isMobile }"
          :style="{ background: '#f4e2d4', marginLeft: isMobile ? '0' : '44px' }"
        >
          <img src="@/assets/images/home/home-yct-170.png" alt="" />
          <p
            :style="{ marginTop: isMobile ? '20px' : '38px' }"
            v-html="$t('ytc_beginner_advanced')"
          ></p>
          <router-link to="/chooselevel/index" class="look-more"
            ><span @click="onClickMoreYct">{{ $t('more') }}</span></router-link
          >
        </div>
      </div>
      <div v-if="false" class="level-footer" :class="{ 'level-footer-mobile': isMobile }">
        <h1>{{ $t('coming_end') }}</h1>
        <p v-html="$t('level_oral_tests')"></p>
        <p>{{ $t('candidates_proficiency_speaking') }}</p>
      </div>

      <div class="helping-students" style="margin-top: 60px">
        <div :class="{ 'home-main': !isMobile }">
          <h1>{{ $t('help_students_for_testing') }}</h1>
          <p v-html="$t('help_students_for_testing_desc')"></p>
          <router-link
            to="/forTeachers/index"
            class="helping-students-route"
            style="margin-top: 25px"
            >{{ $t('for_teachers') }}</router-link
          >
        </div>
      </div>
      <div class="helping-students">
        <div :class="{ 'home-main': !isMobile }">
          <h1>{{ $t('become_partner') }}</h1>
          <p>
            {{ $t('become_partner_desc') }}
          </p>
        </div>
        <span class="helping-students-route" style="margin-top: 40px" @click="onClickPartner">{{
          $t('partnership')
        }}</span>
      </div>
    </div>
    <div>
      <img src="@/assets/images/home/lorem.png" alt="" style="display: block; width: 100%" />
      <div class="lorem-bg" :class="{ 'lorem-bg-mobile': isMobile }">
        <div class="home-main" :class="{ 'home-main-mobile': isMobile }">
          <div class="flex flex-between test-card" :class="{ 'test-card-mobile': isMobile }">
            <div class="test-date" :class="{ 'test-date-mobile': isMobile }" @click="onClickDate">
              <p class="test-card-text">{{ $t('check_test_dates') }}</p>
              <img src="@/assets/images/home/test-date.png" alt="" class="test-date-img" />
            </div>
            <div class="test-book" :class="{ 'test-book-mobile': isMobile }" @click="onClickJoin">
              <p class="test-card-text">{{ $t('book_test') }}</p>
              <img src="@/assets/images/home/book-test.png" alt="" class="test-book-img" />
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <DialogTest :visible="centerDialogVisible" @update:visible="dialogUpdate"></DialogTest>
    <el-dialog
      width="95%"
      :show-close="false"
      :visible.sync="dialogNeedApp"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="practice-root"
    >
      <NeedDownload @close-modal="dialogNeedApp = false" />
    </el-dialog>
    <!-- 自由练习弹窗 -->
    <el-dialog
      :visible.sync="freePracticeDialogVisible"
      :width="isMobile ? '90%' : '1024px'"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="practice-root"
    >
      <FreePractice
        v-if="freePracticeDialogVisible"
        :initial-type="freePracticeType"
        :initial-level="freePracticeLevel"
        @closeDialog="freePracticeDialogVisible = false"
      ></FreePractice>
    </el-dialog>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'
import analytics from '@/utils/AnalyticsCenter'
import { mixinMixpanel } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import { IS_CHINA } from '@/config'
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
import axios from 'axios'
import { apiRequest } from '@/serves/http'
import { getToken } from '@/utils/cache'
import ApiPath from '@/serves/path'
// 在线视频播放组件
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import { videoPlayer } from 'vue-video-player'
import DownLoadApp from '@/components/common/DownLoadApp.vue'
import NeedDownload from '@/views/hsk/components/need-download-app.vue'
import DialogTest from '@/components/DialogTest'
import FreePractice from '@/views/hsk/components/freePractice'
import { jumpToHankao } from '@/utils/utils'
import { isMobileUA } from '@/utils/browser'
export default {
  name: 'HomeView',
  components: {
    SvgIcon,
    videoPlayer,
    DownLoadApp,
    NeedDownload,
    DialogTest,
    FreePractice,
  },
  mixins: [mixinMixpanel],
  data() {
    return {
      // 首次渲染即取正确值，避免移动端先渲染 PC 版再切换造成布局跳变（CLS）
      isMobile: isMobileUA(),
      swiper: null,
      mySwiper: null,
      modileSwiper: null,
      articleList: [],
      dialogNeedApp: false, // 移动端下载App弹窗
      centerDialogVisible: false, // 免费等级测试弹窗
      freePracticeDialogVisible: false, // 自由练习弹窗
      freePracticeType: '', // 自由练习类型：FLASHCARDS, EXERCISE, ANALYSE
      freePracticeLevel: '', // 自由练习等级：hsk1, hsk2, ...
      confidenceList: [
        {
          icon: require('@/assets/images/home/ready-2.svg'),
          title: this.$t('real_hsk_exam_content_new'),
          desc: this.$t('real_hsk_exam_desc_new'),
        },
        {
          icon: require('@/assets/images/home/ready-1.svg'),
          title: this.$t('official_level_scoring_new'),
          desc: this.$t('official_level_scoring_desc'),
        },
        {
          icon: require('@/assets/images/home/ready-3.svg'),
          title: this.$t('vocabulary_boost_new'),
          desc: this.$t('vocabulary_boost_desc_new'),
        },
      ],
      howWorkList: [
        {
          title: this.$t('choose_your_level'),
          desc: this.$t('choose_your_level_desc'),
        },
        {
          title: this.$t('practise_and_learn'),
          desc: this.$t('practise_and_learn_desc'),
        },
        {
          title: this.$t('track_your_progress'),
          desc: this.$t('track_your_progress_desc'),
        },
      ],
      answersList: [
        {
          icon: require('@/assets/images/home/answer-1.svg'),
          title: this.$t('faq'),
          desc: this.$t('faq_desc'),
          link: '/index.html',
          isExternal: true,
          btnStr: this.$t('faq_btn'),
        },
        {
          icon: require('@/assets/images/home/answer-2.svg'),
          title: this.$t('blog'),
          desc: this.$t('blog_desc'),
          link: '/index.html',
          isExternal: true,
          btnStr: this.$t('blog_btn'),
        },
        {
          icon: require('@/assets/images/home/answer-3.svg'),
          title: this.$t('contact'),
          desc: this.$t('contact_desc'),
          link: '/feedback',
          btnStr: this.$t('contact_btn'),
        },
      ],
      bgImages: [
        require('@/assets/images/home/mobile-home-bg-1.png'),
        require('@/assets/images/home/mobile-home-bg-2.png'),
        require('@/assets/images/home/mobile-home-bg-3.png'),
      ], // 背景图片路径数组
      bgImageIndex: 0, // 当前背景图片索引
      bgImageUrl: require('@/assets/images/home/home-header-new.png'),
      timer: null,
      banners: [],
      activeCardIndex: 0,
      localAvatars: [
        'feedback-photo-1.png',
        'feedback-photo-2.png',
        'feedback-photo-3.png',
        'feedback-photo-4.png',
        'feedback-photo-5.png',
        'feedback-photo-6.png',
        'feedback-photo-7.png',
        'feedback-photo-8.png',
        'feedback-photo-9.png',
      ],
      videoUrl: '',
      institutionalImages: [
        require('@/assets/images/home/institutional-1.png'),
        require('@/assets/images/home/institutional-2.png'),
        require('@/assets/images/home/institutional-3.png'),
      ],
      currentInstitutionalSlide: 0,
      institutionalTimer: null,
      selectedLevel: '',
      selectedMethod: 'word_practice',
      practiceMethodList: [
        { key: 'word_flashcards', label: this.$t('word_flashcards') },
        { key: 'word_practice', label: this.$t('word_practice') },
        { key: 'analyse_text', label: this.$t('analyse_text') },
      ],
    }
  },
  watch: {
    isMobile: {
      handler(val) {
        if (val) {
          if (this.banners.length > 0) {
            this.initSwiperMobile()
          }
        } else {
          clearInterval(this.timer)
          if (this.banners.length > 0) {
            this.initBannerContainer()
          }
          if (this.articleList.length > 0) {
            this.initMySwiper()
          }
        }
      },
      immediate: true,
    },
    '$store.state.publicUrl.mockPublicUrl': {
      handler(val) {
        if (val) {
          this.videoUrl = this.$store.state.publicUrl.mockPublicUrl + '/static/promo.mp4'
        }
      },
      immediate: true,
    },
    // 当 hskLevels 有数据时，设置默认选中用户当前等级或第一项
    hskLevels: {
      handler(val) {
        if (val && val.length > 0 && !this.selectedLevel) {
          // 优先使用用户当前选中的等级
          if (this.currentUserLevelName && val.includes(this.currentUserLevelName)) {
            this.selectedLevel = this.currentUserLevelName
          } else {
            this.selectedLevel = val[0]
          }
        }
      },
      immediate: true,
    },
    // 当用户等级变化时，更新选中状态
    currentUserLevelName: {
      handler(val) {
        if (val && this.hskLevels.includes(val)) {
          this.selectedLevel = val
        }
      },
    },
  },
  mounted() {
    // console.log(sentryerrornew)
  },
  beforeMount() {
    this.$_resizeHandler()
    window.addEventListener('resize', this.$_resizeHandler)
    clearInterval(this.timer)
  },
  created() {
    // 首页埋点
    analytics.logEvent('hskweb_official_view')
    this.getBannerText()
    this.startInstitutionalSwiper()
  },
  computed: {
    isChina() {
      return IS_CHINA
    },
    // 预览配置
    playerOptions() {
      return {
        // width: '1675px',
        // height: '628px',
        aspectRatio: '2:1',
        autoplay: false,
        muted: false,
        controls: true,
        preload: 'auto',
        sources: [
          {
            type: 'video/mp4',
            src: this.videoUrl,
          },
        ],
      }
    },
    langTitle() {
      return (lang) => {
        if (this.$i18n.locale != 'en') {
          return (
            lang
              .split('[:')
              .find((item) => item.startsWith('zh'))
              ?.split(']')?.[1] || ''
          )
        } else {
          return (
            lang
              .split('[:')
              .find((item) => item.startsWith(this.$i18n.locale))
              ?.split(']')?.[1] || ''
          )
        }
      }
    },
    ...mapGetters('level', {
      levelTypeName: 'levelTypeName',
    }),
    ...mapState({
      // 等级信息
      levelActiveIndex: (state) => state.level.levelActiveIndex,
      levelActive: (state) => state.level.levelActive,
      levelList: (state) => state.level.levelList,
      isGrading: (state) => state.grade.isGrading,
    }),
    // 从接口返回的第一组数据中提取等级列表
    hskLevels() {
      if (!this.levelList || this.levelList.length === 0) return []
      // 取第一组数据（通常是HSK）
      const firstGroup = this.levelList[0]
      if (!firstGroup || !firstGroup.levels) return []
      // 返回等级名称数组
      return firstGroup.levels.map((item) => item.level_name)
    },
    // 获取当前用户选中的等级名称
    currentUserLevelName() {
      if (!this.levelList || this.levelList.length === 0) return ''
      if (!this.levelActive) return ''
      // 在第一组数据中查找当前选中的等级
      const firstGroup = this.levelList[0]
      if (!firstGroup || !firstGroup.levels) return ''
      const currentLevel = firstGroup.levels.find((item) => item.id == this.levelActive)
      return currentLevel ? currentLevel.level_name : ''
    },
    isChinese() {
      let local = this.$i18n.locale || localStorage.getItem('language')
      return local != 'zh'
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler)
    this.stopInstitutionalSwiper()
  },
  methods: {
    getImagePath(index) {
      return require(`@/assets/images/home/${this.localAvatars[index % this.localAvatars.length]}`)
    },
    // 点击考试日期按钮
    onClickDate() {
      analytics.logEvent('hskweb_checktestdates_click')
      jumpToHankao(true)
    },
    // 点击报名考试按钮
    onClickJoin() {
      analytics.logEvent('hskweb_bookatest_click')
      jumpToHankao(false)
    },
    // 计算当前评论id集合 共三个
    getReviewIds() {
      let total = this.banners.length
      if (!total || total <= 0) {
        // 无数据
        return []
      }
      // 当前值最小为 1 最大应为数组长度， 但是实际上会超上限 例如total=9 max会为10 11，存在两个超上限值
      let current = this.modileSwiper.activeIndex
      if (current > total) current -= total
      let first = current - 1
      if (first < 0) first = total - 1
      let third = current + 1
      if (third >= total) third = 0
      console.log('当前评论集合', first, current, third)
      return [first, current, third]
    },
    // 点击使用移动端
    onClickMoreHsk() {
      analytics.logEvent('hskweb_intromore_click', { type: 'hsk' })
    },
    // 点击 YCT 更多按钮
    onClickMoreYct() {
      analytics.logEvent('hskweb_intromore_click', { type: 'yct' })
    },
    // 点击评论翻页左箭头
    onClickLeftArrow() {
      analytics.logEvent('hskweb_reviewswitch_click', {
        direction: 'left',
      })
    },
    // 点击评论翻页右箭头
    onClickRightArrow() {
      analytics.logEvent('hskweb_reviewswitch_click', {
        direction: 'right',
      })
    },
    // 点击首屏 Hero 区"开始练习"按钮 - 手机端不弹窗，直接跳转
    onClickHeroStart() {
      analytics.logEvent('hskweb_getstarted_click', {
        position: 'above_the_fold',
        banner_text_ids: this.getReviewIds(),
      })
      this.goCheckLevel(true)
    },
    // 点击 How it Works 区"开始"按钮 - 手机端不弹窗，直接跳转
    onClickHowItWorksStart() {
      analytics.logEvent('hskweb_getstarted_click', {
        position: 'above_the_fold',
        banner_text_ids: this.getReviewIds(),
      })
      this.goCheckLevel(true)
    },
    // 点击卡片0详情区"免费水平自测"按钮 - 手机端弹窗下载App
    onClickCard0LevelTest() {
      analytics.logEvent('hskweb_getstarted_click', {
        position: 'above_the_fold',
        banner_text_ids: this.getReviewIds(),
      })
      const isMobile = document.body.getBoundingClientRect().width - 1 < 768
      if (isMobile) {
        this.dialogNeedApp = true
        return
      }
      if (this.isGrading) {
        this.$router.push({ name: 'levelReport' })
      } else {
        this.centerDialogVisible = true
      }
    },
    // 点击卡片1"模考"按钮 - 手机端弹窗下载App，PC端跳转并使用选中的等级
    onClickCard1MockTest() {
      analytics.logEvent('hskweb_getstarted_click', {
        position: 'above_the_fold',
        banner_text_ids: this.getReviewIds(),
      })
      const isMobile = document.body.getBoundingClientRect().width - 1 < 768
      if (isMobile) {
        this.dialogNeedApp = true
        return
      }
      // PC端：使用选中的等级进行跳转
      this.goCheckLevelWithSelected(this.selectedLevel)
    },
    // 点击 Banner 评论区"开始学习"按钮 - 手机端弹窗下载App
    onClickBannerStart() {
      analytics.logEvent('hskweb_getstarted_click', {
        position: 'review',
        banner_text_ids: this.getReviewIds(),
      })
      this.goCheckLevel()
    },
    // 点击词汇练习方法按钮（单词闪卡、单词练习、文本分析）
    onClickPracticeMethod(methodKey) {
      analytics.logEvent('hskweb_practice_method_click', {
        method: methodKey,
      })
      // 移动端弹窗提示下载App
      if (this.isMobile) {
        this.dialogNeedApp = true
        return
      }
      // 将 methodKey 转换为自由练习组件的 key 格式
      const methodMap = {
        word_flashcards: 'FLASHCARDS',
        word_practice: 'EXERCISE',
        analyse_text: 'ANALYSE',
      }
      this.freePracticeType = methodMap[methodKey]
      // 将选中的等级名称转换为小写格式（如 HSK1 -> hsk1）
      this.freePracticeLevel = this.selectedLevel ? this.selectedLevel.toLowerCase() : ''
      this.freePracticeDialogVisible = true
    },
    goCheckLevel(skipMobileCheck = false) {
      const isMobile = document.body.getBoundingClientRect().width - 1 < 768
      if (isMobile && !skipMobileCheck) {
        this.dialogNeedApp = true
        return
      }
      // 需要判断如果存储有误，更新存储，以LevelActive为准；
      if (this.$store.state.user.login && getToken()) {
        if (this.$store.state.level.levelId) {
          console.log('levelActiveIndex', this.levelActiveIndex)
          console.log(this.$store.state.level.levelId, 'this.$store.state.level.levelId')
          console.log(this.levelTypeName, 'this.$store.state.level.levelId')
          if (this.levelTypeName == 'hsk-3') {
            this.$router.push({
              path: `/new-hsk/tests`,
              query: {
                level: `${this.levelTypeName}${this.levelActiveIndex}`,
              },
            })
          } else {
            this.$router.push({
              path: `/${this.levelTypeName || 'hsk'}/tests`,
              query: {
                level: `${this.levelTypeName}${this.levelActiveIndex}`,
              },
            })
          }

        } else {
          this.$router.push({ path: '/chooselevel/index' })
        }
      } else {
        this.$router.push({ path: '/chooselevel/index' })
      }
    },
    // 使用选中的等级进行跳转（用于卡片1模考按钮）
    goCheckLevelWithSelected(selectedLevel) {
      // 将选中的等级转换为小写格式用于跳转
      const levelQuery = selectedLevel ? selectedLevel.toLowerCase() : ''
      if (this.$store.state.user.login && getToken()) {
        if (levelQuery) {
          // 根据等级判断是 HSK 3.0 还是普通 HSK
          if (levelQuery.includes('hsk-3')) {
            this.$router.push({
              path: `/new-hsk/tests`,
              query: {
                level: levelQuery,
              },
            })
          } else {
            this.$router.push({
              path: `/${levelQuery.startsWith('hskk') ? 'hskk' : 'hsk'}/tests`,
              query: {
                level: levelQuery,
              },
            })
          }
        } else {
          // 没有选中等级，跳转到选择等级页
          this.$router.push({ path: '/chooselevel/index' })
        }
      } else {
        // 未登录，跳转到选择等级页
        this.$router.push({ path: '/chooselevel/index' })
      }
    },
    checkForDuplicates(existingList, avatar) {
      if (existingList.length < 2) {
        return false
      }
      const lastIndex = existingList.length - 1
      const secondLastIndex = existingList.length - 2
      return (
        existingList[lastIndex].avatar === avatar && existingList[secondLastIndex].avatar === avatar
      )
    },

    $_resizeHandler() {
      // 必须同步赋值：延后到宏任务会让首屏先按 PC 版绘制再切换，造成布局跳变（CLS）
      this.isMobile = isMobileUA()
      if (!this.isMobile && this.timer) {
        clearInterval(this.timer)
      }
    },
    handleClick(key) {
      // TODO：关于我们、意见反馈、app下载地址、copyright
      let mixpanelParams = { position: 'homepage' }
      if (key === 'android') {
        //安卓下载埋点
        analytics.logEvent('hskweb_android_click', mixpanelParams)
        window.open(
          this.isChina
            ? process.env.VUE_APP_MODE == 'prod'
              ? `${this.$store.state.publicUrl.mockPublicUrl}/static/android/com.wohui.mocktest.china-mockChina-prod.apk`
              : `${this.$store.state.publicUrl.mockPublicUrl}/static/android/com.wohui.mocktest.china-mockChina-test.apk`
            : process.env.VUE_APP_MODE == 'prod'
              ? `${this.$store.state.publicUrl.mockPublicUrl}/static/android/com.wohui.mocktest-foreign-prod.apk`
              : `${this.$store.state.publicUrl.mockPublicUrl}/static/android/com.wohui.mocktest-foreign-test.apk`
        )
      } else if (key === 'app-store') {
        //苹果下载埋点
        analytics.logEvent('hskweb_apple_click', mixpanelParams)
        window.open(
          this.isChina
            ? 'https://apps.apple.com/cn/app/hsk-mock-china/id6453362725'
            : 'https://apps.apple.com/cn/app/hsk-mock/id1624661903'
        )
      } else if (key === 'google-play') {
        //谷歌下载埋点
        analytics.logEvent('hskweb_google_click', mixpanelParams)
        window.open('https://play.google.com/store/apps/details?id=com.wohui.mocktest')
      }
    },
    getWohuiBanner() {
      //?category=63&post_status=publish
      axios
        .get(
          'https://articles.wohuimandarin.com/wp-json/wp/v2/posts?category=63&post_status=publish&numberposts=3&offset=0&post_type=post',
          {
            timeout: 60000,
          }
        )
        .then((res) => {
          this.articleList = res.data?.slice(0, 3) || []
          this.initMySwiper()
        })
    },
    getBannerTransferLanguage(transferStr) {
      if (!transferStr) {
        return ''
      }
      let globalLanguage = localStorage.getItem('language')
      let language = 'en'
      if (globalLanguage == 'zh' || globalLanguage == 'cn') {
        language = 'zh'
      }
      return JSON.parse(transferStr)[language]
    },
    getBannerText() {
      apiRequest.get(ApiPath.bannerText).then((res) => {
        this.banners = res.data.banners || []
        this.banners.forEach((item) => {
          console.log(item)
          item.text = this.getBannerTransferLanguage(item.text_trans)
          item.title = this.getBannerTransferLanguage(item.title_trans)
        })
        if (this.isMobile) {
          this.initSwiperMobile()
        } else {
          this.initBannerContainer()
        }
      })
    },
    initSwiperMobile() {
      this.swiper = null
      this.$nextTick(() => {
        this.modileSwiper = new Swiper('.swiper-container-mobile', {
          slidesPerView: 1,
          watchSlidesProgress: true,
          spaceBetween: 20,
          centeredSlides: false,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.banner-pagination',
          },
        })
      })
    },
    initBannerContainer() {
      this.swiper = null
      this.$nextTick(() => {
        // 向上取整
        const count = (window.document.body.clientWidth / 357).toFixed(0)
        console.log('count', count)
        this.modileSwiper = new Swiper('.banner-container', {
          slidesPerView: count,
          centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左。
          spaceBetween: 20,
          loop: true,
          autoplay: {
            delay: 3000,
          },
          navigation: {
            nextEl: '.banner-button-next',
            prevEl: '.banner-button-prev',
          },
        })

        this.modileSwiper.el.addEventListener(
          'mouseenter',
          function () {
            this.swiper.autoplay.stop()
          },
          false
        )

        this.modileSwiper.el.addEventListener(
          'mouseleave',
          function () {
            this.swiper.autoplay.start()
          },
          false
        )
      })
    },
    initMySwiper() {
      this.$nextTick(() => {
        this.mySwiper = new Swiper('.mySwiper', {
          loop: true,
          slidesPerView: 3,
          spaceBetween: 100,
          navigation: {
            nextEl: '.mySwiper-button-next',
            prevEl: '.mySwiper-button-prev',
          },
        })
      })
    },
    onClickPartner() {
      console.log('点击进入表单')
      this.$router.push({ path: '/partnerforms/index' })
    },
    handleCardClick(index) {
      this.activeCardIndex = index
    },
    onClickInstitutional() {
      this.$router.push({ path: '/solutions' })
    },
    // 弹窗显示状态发生变化
    dialogUpdate(val) {
      this.centerDialogVisible = val
    },
    startInstitutionalSwiper() {
      if (!this.institutionalImages || this.institutionalImages.length === 0) return
      this.institutionalTimer = setInterval(() => {
        this.currentInstitutionalSlide = (this.currentInstitutionalSlide + 1) % this.institutionalImages.length
      }, 3000)
    },
    stopInstitutionalSwiper() {
      if (this.institutionalTimer) {
        clearInterval(this.institutionalTimer)
        this.institutionalTimer = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.practice-root {
  ::v-deep .el-dialog__body {
    padding: 0 !important;
  }
}

@media screen and (max-width: 768px) {
  #app .home .home-header {
    .hsk-bg {
      position: relative;
      &-img {
        position: relative;
        z-index: 10;
        display: flex;
        justify-content: center;
        gap: 30px;
        > img {
          width: 49px;
          &:nth-child(n + 2) {
            margin-left: 0;
          }
        }
      }
    }
  }
  .download-app {
    &-box {
      margin-top: 40px;
    }
    &-title {
      font-size: 12px;
      color: #fff;
      line-height: 16px;
      margin-bottom: 10px;
      text-align: center;
    }
  }
  .download-swiper-title {
    font-size: 12px;
    color: #2c2f46;
    line-height: 16px;
    margin-bottom: 10px;
    margin-top: 40px;
    text-align: center;
  }
}

/*播放按钮设置成宽高一致，圆形，居中*/
.video-player {
  margin: 78px 0px;
  border-radius: 12px;

  ::v-deep .video-js {
    border-radius: 12px;
  }

  ::v-deep .vjs-tech {
    border-radius: 12px;
  }
}
.m-video-player {
  margin: 25px 20px 0 20px;
  border-radius: 12px;
  ::v-deep .vjs-big-play-button {
    transform: scale(0.7);
  }
}

::v-deep .vjs-custom-skin > .video-js .vjs-big-play-button {
  outline: none;
  border: none;
  width: 100px;
  height: 100px !important;
  background-color: rgba(0, 0, 0, 0) !important;
}

::v-deep .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #ffffff40;
  font-size: 100px;
  position: relative;
  // background: url('../../assets/images/btn_play_hsk.png') no-repeat;
  background-size: 100% 100%;
}

.home-main {
  width: 1200px;
  margin: 0 auto;

  &-mobile {
    width: 100%;
  }
}

.home-main-full {
  background: #f0f0f2;
}

// .icon-98 {
//   width: 98px;
//   height: 98px;
// }
// .icon-116 {
//   width: 116px;
//   height: 95px;
// }
.home {
  height: 100%;
  background-color: #ffffff;
  .home-header {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 400px;
    background: url(~@/assets/images/home/home-header-new.png) no-repeat center/cover;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    &-layer {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.1);
      position: absolute;
      top: 0;
      left: 0;
    }
    &-mobile {
      height: 464px;
      padding: 0 50px;
    }
    .flex-column {
      flex-direction: column;
      // max-height: 400px;
      // overflow: hidden;
      // justify-content: space-between;
      // align-self: flex-start;
    }
    .header-logo {
      height: 47px;
      margin-bottom: 40px;
    }

    .header-title {
      color: var(--Wohui-White, #fff);
      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.35);
      font-family: Calibri;
      font-size: 100px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-align: center;
      &-mobile {
        font-size: 32px;
      }
      &-bg-box {
        width: 1200px;
        position: relative;

        &-mobile {
          width: 100%;
          padding-top: 50px;
        }
      }
      &-text {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 10;
      }
      &-bg {
        width: 100%;
        height: 100%;
        position: absolute;
        border-radius: 236px;
        border: 1px solid #000;
        opacity: 0.24;
        background: #080b24;
        filter: blur(63.5px);
        top: 0;
        left: 0;
      }
    }
    .header-desc {
      color: #fff;
      text-align: center;
      font-family: Calibri;
      font-size: 26px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      width: 878px;
      margin: 0 auto;
      margin-top: 21px;

      &-mobile {
        width: 100%;
        font-size: 15px;
      }
    }
    .hsk-bg {
      position: relative;
      &-layer {
        width: 100%;
        height: 100%;
        position: absolute;
        border-radius: 236px;
        border: 1px solid #000;
        opacity: 0.24;
        background: #080b24;
        filter: blur(63.5px);
        top: 0;
        left: 0;
      }
      &-img {
        position: relative;
        z-index: 10;
        > img {
          &:nth-child(n + 2) {
            margin-left: 60px;
          }
        }
      }
    }
    .started {
      width: 191px;
      height: 48px;
      border-radius: 50px;
      margin-top: 10%;
      color: #fff;
      text-align: center;
      font-family: Calibri;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      &-mobile {
        width: 182px;
        height: 50px;
        font-size: 18px;
      }
    }
    .home-header-footer {
      width: 100%;
      height: 38px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.4);
      position: absolute;
      bottom: 0;
      left: 0;
      color: #fff;
      font-family: Calibri;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      &-mobile {
        font-size: 11px;
        padding: 0 28px;
      }
    }
    .home-pay-tip-box {
      position: absolute;
      width: 100%;
      bottom: 0px;
      background-color: #00000033;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 11px 20px;
      .pay-tip-front {
        position: relative;
        top: 1px;
        margin-left: 5px;
        font-family: Proxima Nova;
        font-size: 12px;
        font-weight: 700;
        line-height: 16px;
        // letter-spacing: 0em;
        vertical-align: middle;
        text-align: left;
        color: #ffffff;
      }
    }
  }
  .confidence {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: Calibri;

    &-mobile {
      width: 100%;
    }

    .confidence-header {
      color: #2d2f47;
      font-size: 46px;
      font-style: normal;
      font-weight: 700;
      line-height: 70px;
      text-align: center;
      padding-top: 55px;
      margin-bottom: 60px;
      &-mobile {
        font-size: 32px;
        // margin-top: 40px;
        margin-bottom: 40px;
        color: var(--Wohui-0, #2c2f46);
      }
    }
    .confidence-card {
      width: 1080px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 95px;

      &-mobile {
        width: 100%;
        display: block;
        padding-left: 10%;
        padding-right: 10%;
      }

      .confidence-card-wrapper {
        display: contents;

        @media (max-width: 768px) {
          display: block;
          margin-bottom: 32px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .confidence-card-item {
        position: relative;

        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: -10px;
          left: -10px;
          z-index: 1;
          background: $yellow;
          border-radius: 12px;
          transition: all 0.4s ease-in-out;
        }

        &-inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 55px 44px;
          background: #fff;
          border-radius: 12px;
          text-align: center;
          row-gap: 25px;
          cursor: pointer;
          position: relative;
          z-index: 2;
          transition: all 0.2s ease-in-out;
        }

        &.is-active {
          &::before {
            transform: translate(10px, 10px);
          }
          .confidence-card-item-inner {
            transform: translate(-10px, -10px);
          }
        }

        &-icon {
          width: 62px;
          height: 62px;
        }
        &-title {
          font-size: 24px;
          line-height: 25px;
          min-height: 50px;
          font-weight: bolder;
          color: #2d2f47;
        }
        &-desc {
          font-size: 18px;
          line-height: 22px;
          color: #717171;
          height: 66px;
        }
      }
    }

    .started {
      width: 191px;
      height: 48px;
      border-radius: 50px;
      color: #fff;
      text-align: center;
      font-family: Calibri;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-top: 70px;
      &-mobile {
        width: 182px;
        height: 50px;
        font-size: 18px;
      }
    }
  }

  .how-work-container {
    display: none;
    position: relative;
    background: #e5e7eb;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 160px;
      height: 180px;
      background: url('@/assets/images/home/ring-1.svg') no-repeat;
      z-index: 0;
    }
  }

  .how-work {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: Calibri;

    &-mobile {
      width: 100%;
    }

    .how-work-header {
      color: #2d2f47;
      font-family: Calibri;
      font-size: 46px;
      font-style: normal;
      font-weight: 700;
      line-height: 70px;
      text-align: center;
      padding-top: 55px;
      margin-bottom: 60px;
      position: relative;
      z-index: 2;

      &-mobile {
        font-size: 32px;
        margin-top: 40px;
        margin-bottom: 10px;
        color: var(--Wohui-0, #2c2f46);
      }
    }
    .how-work-card {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 50px;

      &-mobile {
        grid-template-columns: repeat(1, 1fr);
        padding-left: 10%;
        padding-right: 10%;
      }

      .how-work-card-item {
        position: relative;

        &-inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 65px 44px;
          background: #f0f0f2;
          border-radius: 12px;
          text-align: center;
          row-gap: 16px;
          cursor: pointer;
          z-index: 2;
          transition: all 0.4s ease-in-out;

          &:hover {
            transform: translateY(-20px);
            background: #fff;
            box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.1);
          }
        }

        &-icon {
          width: 38px;
          height: 38px;
          border: $yellow 2px solid;
          line-height: 34px;
          border-radius: 19px;
          font-size: 30px;
          font-weight: 600;
        }
        &-title {
          font-size: 24px;
          line-height: 25px;
          min-height: 50px;
          font-weight: bolder;
          color: #2d2f47;
        }
        &-desc {
          font-size: 18px;
          line-height: 22px;
          color: #717171;
          height: 66px;
        }
      }
    }

    .started {
      width: 191px;
      height: 48px;
      border-radius: 50px;
      color: #fff;
      text-align: center;
      font-family: Calibri;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-top: 70px;
      &-mobile {
        width: 182px;
        height: 50px;
        font-size: 18px;
      }
    }
  }

  .answers {
    width: 960px;
    margin: 0 auto;
    padding-bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: Calibri;

    &-mobile {
      width: 100%;
    }

    .answers-header {
      color: #2d2f47;
      font-family: Calibri;
      font-size: 46px;
      font-style: normal;
      font-weight: 700;
      line-height: 70px;
      text-align: center;
      padding-top: 55px;
      margin-bottom: 60px;
      &-mobile {
        font-size: 32px;
        line-height: 40px;
        // margin-top: 40px;
        margin-bottom: 40px;
        color: var(--Wohui-0, #2c2f46);
      }
    }
    .answers-card {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 50px;

      &-mobile {
        grid-template-columns: repeat(1, 1fr);
        padding-left: 10%;
        padding-right: 10%;
      }

      .answers-card-item {
        position: relative;

        &-inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 65px 44px;
          background: #ffffff;
          border-radius: 12px;
          text-align: center;
          row-gap: 16px;
          cursor: pointer;
          z-index: 2;
          transition: all 0.4s ease-in-out;

          &:hover {
            transform: translateY(-8px);
            background: #fff;
            box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.1);
          }
        }

        &-icon {
          width: auto;
          height: 82px;
        }
        &-title {
          font-size: 24px;
          line-height: 25px;
          min-height: 50px;
          font-weight: bolder;
          color: #2d2f47;
        }
        &-desc {
          font-size: 18px;
          line-height: 22px;
          color: #717171;
          height: 110px;
        }

        &-btn {
          font-size: 16px;
          line-height: 25px;
          display: flex;
          margin-top: 20px;
          justify-content: center;
          color: #555775;
          column-gap: 8px;

          & > img {
            color: red;
          }
        }
      }
    }
  }

  .banner {
    background: url('@/assets/images/home/ring-2.png') no-repeat right center;

    .banner-title {
      color: #2d2f47;
      font-family: Calibri;
      font-size: 46px;
      font-style: normal;
      font-weight: 700;
      line-height: 70px;
      text-align: center;
      padding-top: 55px;
      margin-bottom: 0px;
      &-mobile {
        font-size: 32px;
        margin-top: 40px;
        margin-bottom: 10px;
        line-height: 40px;
        color: var(--Wohui-0, #2c2f46);
      }
    }

    .banner-bg {
      // background: #f4eeea;
      overflow: hidden;
      .banner-box {
        width: 95%;
        margin: 0 auto;
        margin-top: 58px;
        position: relative;
        .banner-card {
          width: 337px;
          height: 302px;
          border-radius: 70px;
          background: #ffffff;
          box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
          padding: 32px;
          box-sizing: border-box;
          &-title {
            color: #2d3047;
            text-align: left;
            font-family: Calibri;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 18px;
          }
          &-text {
            color: #474b64;
            text-align: center;
            font-family: Calibri;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-top: 32px;
          }
          &-img {
            width: 42px;
            height: 42px;
            border-radius: 50%;
          }
        }
        .banner-button-prev {
          position: absolute;
          top: 50%;
          left: -90px;
          z-index: 20;
          transform: translateY(-50%);
          cursor: pointer;
        }
        .banner-button-next {
          position: absolute;
          top: 50%;
          right: -90px;
          z-index: 20;
          transform: translateY(-50%);
          cursor: pointer;
        }
        .swiper-container {
          width: 100%;
          height: 100%;
        }
        .swiper-slide {
          text-align: center;
          font-size: 18px;
          /* Center slide text vertically */
          display: -webkit-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          -webkit-justify-content: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: center;
          transition: 300ms;
          transform: scale(1);
          &-active,
          &-duplicate-active {
            transform: scale(1);
            z-index: 10;
          }
        }
      }
      .banner-box-mobile {
        width: 100%;
        margin-top: 40px;
        position: relative;
        .swiper {
          width: 100%;
          height: 100%;
        }
        .swiper-container {
          margin-left: 20px;
        }
        .banner-card-mobile {
          width: 100%;
          height: 100%;
          border-radius: 18px;
          background: #ffffff;
          box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
          padding: 36px 20px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          &-title {
            color: #2d3047;
            text-align: center;
            font-family: Calibri;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-top: 18px;
            margin-bottom: 34px;
          }
          &-text {
            color: #474b64;
            text-align: center;
            font-family: Calibri;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
          &-img {
            width: 88px;
            height: 88px;
            border-radius: 50%;
          }
        }
        .swiper-slide-mobile {
          width: 318px;
          height: 390px;
        }
        .banner-pagination {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 38px;
          margin-bottom: 22px;
          ::v-deep .swiper-pagination-bullet {
            width: 7px;
            height: 3px;
            background: #f1ddd0;
            border-radius: 1.5px;
            transition: 0.3s linear;
            margin-right: 5px;
          }
          ::v-deep .swiper-pagination-bullet-active {
            width: 16px;
            background: #faae56;
            transition: 0.3s linear;
          }
        }
      }

      .started-btn {
        margin-top: 56px;
        margin-bottom: 75px;
        flex-direction: column;
        .get-started {
          width: 300px;
          height: 60px;
          border-radius: 50px !important;
          color: #fff;
          text-align: center;
          font-family: Calibri;
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
        .experience {
          color: #faaf56;
          text-align: center;
          font-family: Calibri;
          font-size: 22px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          text-decoration-line: underline;
          margin-top: 20px;
        }
      }
    }
  }
  .move {
    height: 419px;
    background-image: url(~@/assets/images/home/download-bg.png);
    background-size: 100% 100%;
    position: relative;
    &-mobile {
      height: 550px;
      background-image: url(~@/assets/images/home/more-bg-mobile.png);
    }
    .more-title-bg {
      position: absolute;
      display: block;
      top: 0;
      left: 0;
      &-mobile {
        top: -12px;
      }
    }
    .more-footer-bg {
      position: absolute;
      display: block;
      bottom: 0;
      left: 0;
      &-mobile {
        bottom: -12px;
      }
    }
    .move-title {
      color: var(--Wohui-White, #fff);
      font-family: Calibri;
      font-size: 56px;
      font-style: normal;
      font-weight: 600;
      text-align: center;
      line-height: 60px;
      margin-bottom: 22px;
      &-mobile {
        margin-bottom: 12px;
        font-size: 32px;
        padding-top: 80px;
        // margin-top: 80px;
      }
    }
    .more-desc {
      color: $yellow;
      font-family: Calibri;
      font-size: 56px;
      font-style: normal;
      font-weight: 500;
      line-height: 60px;
      text-align: center;
      margin-bottom: 22px;
      &-mobile {
        font-size: 14px;
      }
    }
    .download {
      display: flex;
      align-items: center;
      &-mobile {
        flex-direction: column;
        justify-content: center;
      }
    }
    // .download-item {
    //   width: 275.2px;
    //   height: 80px;
    //   background-repeat: no-repeat;
    //   background-size: cover;
    //   &-mobile {
    //     width: 137.6px;
    //     height: 40px;
    //     margin-bottom: 16px;
    //   }

    //   &.android {
    //     background-image: url('@/assets/images/home/apple.png');
    //   }
    //   &.app-store {
    //     background-image: url('@/assets/images/home/android.png');
    //   }
    //   &.google-play {
    //     background-image: url('@/assets/images/home/google.png');
    //   }
    // }
  }
  .level {
    background-color: #ffffff;
    margin-top: 76px;
    margin-bottom: 90px;
    &-mobile {
      padding: 0 20px;
      flex-direction: column;
      margin-top: 34px;
      // margin-bottom: 30px;
    }
    .level-card {
      width: 577px;
      color: #474b64;
      text-align: center;
      font-family: Calibri;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      border-radius: 18px;
      padding: 36px 114px 15px 114px;
      &-mobile {
        width: 100%;
        padding: 36px 24px 10px 24px;
        box-sizing: border-box;
        margin-bottom: 24px;
      }
      .look-more {
        display: block;
        color: #2d3047;
        font-family: Calibri;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
      }
    }
    .level-footer {
      & h1 {
        color: #474b64;
        text-align: center;
        font-family: Calibri;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-bottom: 14px;
        margin-top: 64px;
      }
      & p {
        color: #696974;
        font-family: Calibri;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: center;
      }
      &-mobile {
        & h1 {
          font-size: 20px;
          margin-top: 16px;
        }
      }
    }
    .helping-students {
      padding: 49px 0 35px 0;
      & h1 {
        color: var(--Wohui-0, #2c2f46);
        font-family: Calibri;
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: 42px;
        text-align: center;
      }
      & p {
        color: #515571;
        text-align: center;
        font-family: Calibri;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top: 20px;
      }
      &-route {
        display: block;
        color: #faaf56;
        text-align: center;
        font-family: Calibri;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-decoration-line: underline;
        cursor: pointer;
      }
      &:hover {
        background: #fafafb;
      }
    }
  }
  .lorem-bg {
    width: 100%;
    background-color: #2c2f46;
    margin-top: -1px;
    overflow: hidden;
    padding-bottom: 102px;
    // padding: 0 360px;
    &-mobile {
      height: auto;
      padding: 36px 29px;
    }

    .test-card {
      margin-top: 65px;
      margin-bottom: 60px;
      cursor: pointer;
      &-mobile {
        flex-direction: column;
        margin-top: 0;
        margin-bottom: 24px;
      }
      &-text {
        position: relative;
        color: #2d3047;
        font-family: Calibri;
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        z-index: 10;
      }
      .test-date {
        width: 558px;
        padding: 58px 40px;
        border-radius: 10px;
        border: 1px solid #d9ecfd;
        background: #fdf1d9;
        position: relative;
        &-img {
          display: block;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
        &-mobile {
          width: 100%;
          padding: 45px 20px;
          margin-bottom: 20px;
        }
      }
      .test-book {
        width: 558px;
        padding: 58px 40px;
        border-radius: 10px;
        border: 1px solid #d9ecfd;
        background: #eaf2f9;
        position: relative;
        &-img {
          display: block;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
        &-mobile {
          width: 100%;
          padding: 45px 20px;
        }
      }
    }

    .swiper-box {
      width: 100%;
      position: relative;
      .icon-58 {
        width: 58px;
        height: 58px;
      }
      .mySwiper-button-prev {
        position: absolute;
        top: 50%;
        left: -80px;
        z-index: 20;
        transform: translateY(-50%);
        cursor: pointer;
      }
      .mySwiper-button-next {
        position: absolute;
        top: 50%;
        right: -80px;
        z-index: 20;
        transform: translateY(-50%);
        cursor: pointer;
      }
      .swiper {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }

      .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 332px;
        height: 482px;
        border-radius: 18px;
        background: #fff;
        .lorem-card {
          height: 100%;
          padding: 28px 40px;
          height: 482px;
          box-sizing: border-box;
          .lorem-more {
            display: block;
            color: #2d3047;
            text-align: center;
            font-family: Calibri;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 32px;
          }
          .lorem-title {
            color: #2d3047;
            text-align: center;
            font-family: Calibri;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-bottom: 20px;
          }
          &-desc {
            margin-top: 20px;
            color: #515571;
            text-align: center;
            font-family: Calibri;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
        }
      }
    }
    .lorem-card-mobile {
      width: 100%;
      height: 482px;
      border-radius: 18px;
      background: #fff;
      margin-bottom: 24px;
      padding: 28px 25px;
      position: relative;
      &-desc {
        margin-top: 20px;
        color: #515571;
        text-align: center;
        font-family: Calibri;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
    .lorem-title-mobile {
      color: #2d3047;
      text-align: center;
      font-family: Calibri;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-bottom: 20px;
    }
    .lorem-more-mobile {
      display: block;
      color: #2d3047;
      text-align: center;
      font-family: Calibri;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 32px;
    }
  }
}

// Institutional Section Styles
.institutional-section {
  background: #e5e7eb;
  padding: 80px 0;
  position: relative;
  overflow: hidden;

  &-mobile {
    padding: 40px 20px;
  }

  .institutional-ring {
    position: absolute;
    width: 300px;
    height: 300px;
    border: 40px solid #faae56;
    border-radius: 50%;
    left: -210px;
    top: 25%;
    transform: translateY(-50%);
    z-index: 1;

    @media (max-width: 768px) {
      width: 200px;
      height: 200px;
      border-width: 30px;
      left: -100px;
    }
  }

  .institutional-container {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 2;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .institutional-title {
    color: #2c2f46;
    font-family: Calibri;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
    margin-bottom: 40px;

    @media (max-width: 768px) {
      font-size: 24px;
      margin-bottom: 24px;
    }
  }

  .institutional-card {
    display: flex;
    background: #fff;
    border-radius: 20px;
    overflow: hidden;
    width: 100%;
    max-width: 1200px;
    min-height: 420px;

    &-mobile {
      flex-direction: column;
      min-height: auto;
    }
  }

  .institutional-left {
    position: relative;
    width: 50%;
    min-height: 420px;
    overflow: hidden;

    @media (max-width: 768px) {
      width: 100%;
      height: 220px;
      min-height: auto;
    }
  }

  .institutional-swiper {
    position: absolute;
    width: 90%;
    height: 90%;
    right: 5%;
    top: 5%;
    overflow: hidden;
    border-radius: 25px;

    @media (max-width: 768px) {
      position: relative;
      width: 100%;
      height: 220px;
      right: 0;
      top: 0;
      border-radius: 12px 12px 0 0;
    }
  }

  .institutional-swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .institutional-swiper-slide {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity 0.5s ease-in-out;

    &.active {
      opacity: 1;
    }
  }

  .institutional-image {
    width: 100%;
    height: 100%;
    object-fit: cover;

    @media (max-width: 768px) {
      height: 220px;
    }
  }

  .institutional-right {
    width: 50%;
    padding: 40px 50px 50px 50px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    @media (max-width: 768px) {
      width: 100%;
      padding: 24px;
    }
  }

  .institutional-desc {
    color: #515571;
    font-family: Calibri;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.7;
    margin-bottom: 42px;
  }

  .institutional-item {
    margin-bottom: 28px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .institutional-item-title {
    color: #2c2f46;
    font-family: Calibri;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .institutional-bullet {
    width: 3px;
    height: 18px;
    background: #faae56;
    border-radius: 2px;
    margin-right: 10px;
    display: inline-block;
  }

  .institutional-item-desc {
    color: #515571;
    font-family: Calibri;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.6;
    padding-left: 13px;
  }

  .institutional-btn {
    margin-top: 32px;
    width: 240px;
    height: 48px;
    border-radius: 50px;
    font-family: Calibri;
    font-size: 16px;
    font-weight: 700;

    @media (max-width: 768px) {
      width: 100%;
      margin-top: 24px;
    }
  }
}

// Confidence Detail Section
.confidence-detail {
  width: 1080px;
  margin: 40px auto 0;
  background: #fff;
  border-radius: 16px;
  padding: 40px 50px;
  box-sizing: border-box;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);

  @media (max-width: 768px) {
    display: none;
  }
}

// 移动端：卡片详情区在各自卡片下方显示
.confidence-detail-mobile {
  display: none;
  background: #fff;
  border-radius: 12px;
  padding: 24px 20px;
  margin-top: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.confidence-detail-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.confidence-detail-desc {
  color: #515571;
  font-family: Calibri;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.7;
  text-align: center;
  margin-bottom: 30px;
  max-width: 700px;
}

.confidence-detail-title {
  color: #2c2f46;
  font-family: Calibri;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;

  &.m-t-20 {
    margin-top: 28px;
  }
}

.confidence-level-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin-bottom: 30px;
}

.confidence-level-tag {
  display: inline-block;
  padding: 8px 22px;
  border-radius: 50px;
  border: 1.5px solid #d0d2de;
  color: #2c2f46;
  font-family: Calibri;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    border-color: #faae56;
    color: #faae56;
  }

  &.active {
    background: #faae56;
    border-color: #faae56;
    color: #fff;
  }
}

.confidence-method-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  margin-bottom: 30px;
}

.confidence-method-btn {
  padding: 12px 28px;
  border-radius: 50px;
  border: none;
  color: #fff;
  font-family: Calibri;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;

  // word_flashcards 和 analyse_text 按钮背景色
  &.method-word_flashcards,
  &.method-analyse_text {
    background: #4f527d;
  }

  // word_practice 按钮背景色
  &.method-word_practice {
    background: #2d2f47;
  }

  &:hover {
    opacity: 0.9;
  }
}

.confidence-detail-btn {
  width: 220px;
  height: 48px;
  border-radius: 50px !important;
  font-family: Calibri;
  font-size: 18px;
  font-weight: 700;
  margin-top: 10px;
  color: #fff;
}
</style>
